import cbx from './cbx.json';
import common from './common.json';

const en = {
  ...common,
  cbx,
};

export default en;
